import { render, staticRenderFns } from "./DeliveryList_List.vue?vue&type=template&id=6b11461b&"
import script from "./DeliveryList_List.vue?vue&type=script&lang=js&"
export * from "./DeliveryList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports